import { getCookie } from './cookies';
import { TRACKED_URL_PARAMS } from './params';

export const TRACKED_COOKIES = [
  ...TRACKED_URL_PARAMS,
  '_fbc', '_fbp', '_ga',
  'referrer',
] as const;

export type TrackedCookie = typeof TRACKED_COOKIES[number];

export type TrackingData = Partial<Record<TrackedCookie, string>>;

export interface SpedyTrackingApi {
  getCookies(): Record<string, string>;
  getTrackingData(): TrackingData;
}

declare global {
  interface Window {
    spedyTracking?: SpedyTrackingApi;
  }
}

function snapshot(): TrackingData {
  const out: TrackingData = {};
  for (const name of TRACKED_COOKIES) {
    const v = getCookie(name);
    if (v !== undefined) out[name] = v;
  }
  return out;
}

export function installApi(): void {
  window.spedyTracking = {
    getCookies: () => ({ ...snapshot() }) as Record<string, string>,
    getTrackingData: () => snapshot(),
  };
}
